import { useLocalization } from '@components/Localization'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Box, Heading, Link } from '@gassan-ui'
import { FaqQuestion } from '@lib/kontent/models/FaqQuestion'
import React, { FC } from 'react'
import freeDeliveryDesktop from './assets/free_delivery_desktop.svg'
import freeDeliveryMobile from './assets/free_delivery_mobile.svg'
import payDesktop from './assets/pay_desktop.svg'
import payMobile from './assets/pay_mobile.svg'
import storeDesktop from './assets/stores_desktop.svg'
import storeMobile from './assets/stores_mobile.svg'

import refundDesktop from './assets/refund_desktop.svg'
import refundMobile from './assets/refund_mobile.svg'
import watchServiceDesktop from './assets/watch_service_desktop.svg'
import watchServiceMobile from './assets/watch_service_mobile.svg'
import jewelServiceDesktop from './assets/jewel_service_desktop.svg'
import jewelServiceMobile from './assets/jewel_service_mobile.svg'
import { Question } from './Question'

const enToNlSlugs = {
  'shipping-and-delivery': 'verzending-en-levering',
  'watch-service': 'horloge-service',
  'jewel-service': 'juwelen-service',
  payments: 'betalen',
  stores: 'vestigingen',
  'return-and-refund': 'retour-en-terugbetaling'
}

type Categories =
  | 'shipping-and-delivery'
  | 'watch-service'
  | 'jewel-service'
  | 'payments'
  | 'stores'
  | 'return-and-refund'

const icons: { [key in Categories]: string[] } = {
  'shipping-and-delivery': [freeDeliveryMobile, freeDeliveryDesktop],
  'watch-service': [watchServiceMobile, watchServiceDesktop],
  'jewel-service': [jewelServiceMobile, jewelServiceDesktop],
  payments: [payMobile, payDesktop],
  stores: [storeMobile, storeDesktop],
  'return-and-refund': [refundMobile, refundDesktop]
}

type Props = {
  parentUrlSlug: string
  variant: Categories
  items: FaqQuestion[]
}

const FaqBlock: FC<Props> = ({ variant, items, parentUrlSlug }) => {
  const { messages, lang } = useLocalization()
  return (
    <Box mb={{ _: '3.5rem', small: '4rem', large: '5rem' }}>
      <Box mb="1.5rem">
        <Box display={['block', 'none']}>
          <img src={icons[variant][0]} alt={variant} />
        </Box>
        <Box display={['none', 'block']}>
          <img src={icons[variant][1]} alt={variant} />
        </Box>
      </Box>
      <Heading variant="h4" as="h3" mb={['1.25rem', '1.5rem']}>
        {messages.faq[variant].title}
      </Heading>
      <Box mb={{ _: '0.5rem', large: '1.5rem' }}>
        {items.slice(0, 5).map((question, index) => (
          <Box display="block" key={index} mb="1rem">
            <LocalizedLink
              href={{
                pathname: `/${messages.urlSlugItems.faqPage}/[slug]`,
                query: { id: question.url_slug.value }
              }}
              as={`/${parentUrlSlug}/${messages.faq[variant].urlSlug}`}
            >
              <Question>{question.title.value}</Question>
            </LocalizedLink>
          </Box>
        ))}
      </Box>
      <Box>
        {items.length > 5 && (
          <LocalizedLink
            href={`/${messages.urlSlugItems.faqPage}/[slug]`}
            as={`/${parentUrlSlug}/${lang === 'nl' ? enToNlSlugs[variant] : variant}`}
          >
            <Link variant="brown">{messages.faq.moreQuestions}</Link>
          </LocalizedLink>
        )}
      </Box>
    </Box>
  )
}

export default FaqBlock
